module.exports = __webpack_public_path__ + "img/print_certificado.d827a5b0.png";